import Vue from 'vue'
import App from './components/App.vue'

import router from './router'
import store from './store/store'

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import money from 'v-money'
Vue.use(money)

import VueClip from 'vue-clip'
Vue.use(VueClip)

import interceptor from './helpers/httpInterceptor'
interceptor()

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

Vue.config.productionTip = false
import auth from "@/api/auth";

import '@/assets/css/font-awesome/css/font-awesome.min.css'
import '@/assets/css/simple-line-icons/css/simple-line-icons.css'
import '@/assets/css/bootstrap.css';
import '@/assets/css/landing-page.css';
import '@/assets/css/screen.css';
import 'vue-select/dist/vue-select.css';

new Vue({
  render: h => h(App), router, store,
  mounted(){
    let oldToken = localStorage.getItem('token')
    if(oldToken) {
      store.commit('setToken', oldToken)

      let oldUser = localStorage.getItem('user')
      if(oldUser!=='undefined') store.commit('setUser', oldUser);
        else auth.logout()

      let checkout = localStorage.getItem('checkout')
      if(checkout) store.commit('updateCheckout', checkout)

    }
  }
}).$mount('#app')
